module.exports = __webpack_public_path__ + "static/media/watch.e236cccf.svg";